// src/store/slices/contentSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { content } from "src/types";

// Initial state for the content slice
const initialState: content.ContentStateType = {
  content: {
    data: null,
    isLoading: false,
    error: null,
  },
  topics: {
    data: null,
    isLoading: false,
    error: null,
  },
};

// Define the content slice
const contentSlice = createSlice({
  name: "content",
  initialState: initialState,
  reducers: {
    getContentRequest: (state, action: PayloadAction<any>) => {
      state.content.isLoading = true;
      state.content.data = null;
      state.content.error = null;
    },
    getContentSuccess: (
      state: content.ContentStateType,
      action: PayloadAction<any>
    ) => {
      state.content.isLoading = false;
      state.content.data = action.payload;
      state.content.error = null;
    },
    getContentError: (
      state: content.ContentStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.content.isLoading = false;
      state.content.data = null;
      state.content.error = error;
    },
    getContentListRequest: (
      state: content.ContentStateType,
      action: PayloadAction<any>
    ) => {
      state.content.isLoading = true;
      state.content.error = null;
    },
    getContentListSuccess: (
      state: content.ContentStateType,
      action: PayloadAction<any>
    ) => {
      state.content.isLoading = false;
      state.content.error = null;
      const isFirstPage = action.payload.page === "1";
      const newData = action.payload.data || [];

      if (isFirstPage || !Array.isArray(state.content.data)) {
        state.content.data = newData;
      } else {
        state.content.data = [...state.content.data, ...newData];
      }
    },
    getContentListError: (
      state: content.ContentStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.content.isLoading = false;
      state.content.data = null;
      state.content.error = error;
    },
    getTopicsRequest: (
      state: content.ContentStateType,
      action: PayloadAction<any>
    ) => {
      state.topics.isLoading = true;
      state.topics.data = null;
      state.topics.error = null;
    },
    getTopicsSuccess: (
      state: content.ContentStateType,
      action: PayloadAction<any>
    ) => {
      state.topics.isLoading = false;
      state.topics.data = action.payload;
      state.topics.error = null;
    },
    getTopicsError: (
      state: content.ContentStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.topics.isLoading = false;
      state.topics.data = null;
      state.topics.error = error;
    },
  },
});

// Export actions and reducer
export const {
  // get content details
  getContentRequest,
  getContentSuccess,
  getContentError,
  getContentListRequest,
  getContentListSuccess,
  getContentListError,
  // get topics
  getTopicsRequest,
  getTopicsSuccess,
  getTopicsError,
} = contentSlice.actions;

export default contentSlice.reducer;
